import request from '@/utils/request'
import qs from 'qs'
//搜索
export function favorAdd (params) {
  return request({
    url: '/business/favor/add',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    token: true,
    data: params,
  })
}
// 删除收藏
export function deleteFavor (favorId) {
  return request({
    url: `/business/favor/delete/${favorId}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/json',
    },
    token: true,
    params: null,
  })
}
export function isFavor (favorId) {
  return request({
    url: `/business/favor/isFavor/${favorId}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
    token: true,
    params: null,
  })
}
//搜索
export function favorList (params) {
  return request({
    url: '/business/favor/list?' + qs.stringify(params),
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
    token: true,
  })
}
export function readList (params) {
  return request({
    url: '/business/read/list?' + qs.stringify(params),
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
    token: true,
  })
}



// WEBPACK FOOTER //
// ./src/api/favor.js